module.exports = __webpack_public_path__ + "59d87eddb549bfa3b8c66c3b5dc47479.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/critical-strike-video-poster.jpg
// module id = 237
// module chunks = 0